// extracted by mini-css-extract-plugin
export default {"spinner":"Loaders_spinner__pJPJY","animation":"Loaders_animation__ReoTs","loader":"Loaders_loader__jY5HD","spin":"Loaders_spin__JSpUE","ldsDualRing":"Loaders_ldsDualRing__KUmcl"};